// extracted by mini-css-extract-plugin
export var chevronIcon = "_9h-2";
export var teamName = "_9h-1";
export var teamSwitcherButton = "_9h-0";